import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import Calendar from '../calendar/Calendar';
import Format from '../Formatter';
import Fa from '../Fa';
import { noop } from '../helpers';

import './date-picker.css';

export default class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
    this.setRef = this.setRef.bind(this);
    this.showDatePickerOverlay = this.showDatePickerOverlay.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  setRef(el) {
    this.el = el;
  }

  handleDateChange(date) {
    if (!date.isSame(this.props.value)) {
      this.props.onChange(date);
    }
    this.hideDatePickerOverlay();
  }

  handleReset() {
    this.props.onChange(null);
  }

  handleOutsideClick(e) {
    if (this.el && !this.el.contains(e.target)) {
      this.hideDatePickerOverlay();
      document.body.removeEventListener('click', this.handleOutsideClick);
    }
  }

  showDatePickerOverlay() {
    this.setState({ visible: true });
    document.body.addEventListener('click', this.handleOutsideClick);
  }

  hideDatePickerOverlay() {
    this.setState({ visible: false });
    if (this.props.onBlur) this.props.onBlur();
  }

  renderCalendarOverlay() {
    return (
      <div className="calendar-overlay">
        <Calendar
          {...this.props}
          onDateChange={this.handleDateChange}
          selected={this.state.selectedDate}
        />
      </div>
    );
  }

  renderResetButton() {
    if (!this.props.required && this.props.value) {
      return (
        <button className="date-picker-reset-button" onClick={this.handleReset}>
          <Fa icon="times-circle" />
        </button>
      );
    }
    return null;
  }

  render() {
    const value = this.props.value;
    const inputClassNames = this.props.className;
    return (
      <div className={classNames('date-picker-wrapper', inputClassNames)} ref={this.setRef}>
        <input
          placeholder={this.props.placeholder}
          type="text"
          className={classNames('form-group-input input-date', inputClassNames)}
          value={value && value.isValid() ? Format.date(value) : ''}
          onClick={this.showDatePickerOverlay}
          onChange={noop}
        />
        {this.renderResetButton()}
        <a
          tabIndex={0}
          className={classNames('date-picker-trigger', inputClassNames)}
          onClick={this.showDatePickerOverlay}
        >
          <Fa icon="calendar" className="date-picker-trigger-icon" />
        </a>

        {this.state.visible ? this.renderCalendarOverlay() : null}
      </div>
    );
  }
}

DatePicker.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.instanceOf(moment),
  required: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};
